import React from 'react';
import { Chip, Popover, Typography } from "@material-ui/core";
import clsx from "clsx";
import '../../index.scss';
import { useTranslation } from "../../langs/useTranslation";
export const SimpleStatusChip = ({
                                   size,
                                   color,
                                   statusLabel,
                                   suffix,
                                   className,
                                   style
                                 }) => {
  const { t } = useTranslation("common");

  return (
    <Chip
      size={size}
      color={color}
      label={
        <>
          {t(`status.${statusLabel}`)}
          {suffix}
        </>
      }
      className={clsx(t(`status.${statusLabel}`), className)}
      style={style}
    />
  );
};

const StatusChip = props => {
    const { data } = props;
    const { t } = useTranslation('common');
    return (
        <span className={`${data} status`}>
            {t(`status.${data}`)}
        </span>
    )
}

export default StatusChip;
